import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment.prod';
import {map, Observable} from 'rxjs';
import {
  MyCustomerDataUseCasePort
} from '@features/customer/application/use_cases/my-customer-data/my-customer-data.use-case.port';
import {
  MyCustomerDataPayloadDto
} from '@features/customer/application/use_cases/my-customer-data/dto/my-customer-data.payload.dto';
import {
  MyCustomerDataResponseDto
} from '@features/customer/application/use_cases/my-customer-data/dto/my-customer-data.response.dto';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';
import {NavigationPort} from '@shared/application/ports/navigation/navigation.port';
import {
  MyCustomerDataHttpPayloadDto
} from '@features/customer/infrastructure/http/my-customer-data/my-customer-data.http.payload.dto';
import {
  MyCustomerDataHttpResponseDto
} from '@features/customer/infrastructure/http/my-customer-data/my-customer-data.http.response.dto';
import {
  MyCustomerDataHttpMapper
} from '@features/customer/infrastructure/http/my-customer-data/my-customer-data.http.mapper';
import {FilterInterface} from '@core/interfaces/filter/filter.interface';
import {HttpHeaders} from '@angular/common/http';
import {UserEntity} from '@features/user/domain/entities/user.entity';

@Injectable()
export class MyCustomerDataHttpAdapter implements MyCustomerDataUseCasePort {

  private readonly url = environment.uri;
  private readonly http = inject(ClientHttpPort);
  private readonly localStoragePort = inject(LocalStoragePort);

  public execute(payload: MyCustomerDataPayloadDto): Observable<MyCustomerDataResponseDto> {
    const myUser: UserEntity | null = this.localStoragePort.getByKey("_user_data");
    if (!myUser) throw new Error("No user data found.");
    const filter: FilterInterface = {
      ...(payload.filter ?? {}),
    }
    filter.singleQuery = ["users_phone_number", "=", `${myUser.phone_number}`]
    if (payload.limit) {
      filter["paginate"] = payload.limit;
    }
    const headers = new HttpHeaders({
      "x-filter-model": JSON.stringify(filter),
    })
    return this.http.get<MyCustomerDataHttpResponseDto>(`${this.url}customers-list`, {headers})
      .pipe(map(MyCustomerDataHttpMapper.toResponse)
      )
  }

}
